import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import React from 'react'

const WindmillImage = (props) => {
  const data = useStaticQuery(graphql`
    query {
      windmillImage: file(
        relativePath: {
          eq: "components/pages/ResponsibleInvestmentPage/Sections/InvestmentSection/img/windmill.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, maxHeight: 936) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)

  return <Img fluid={data.windmillImage.childImageSharp.fluid} {...props} />
}

export default WindmillImage
